import React, { Component } from 'react';
import _ from 'lodash';
import * as R from 'ramda';
import {
  setAddressFormat,
} from '../setters';
import annotNameIncludes from '../../helpers/annotNameIncludes';

const getTemplateAnnots = R.filter(
  (annot) => annotNameIncludes(annot, 'AddressTemplate')
);

export default class SetAddressFormat extends Component {
  constructor(...args) {
    super(...args);
    this.state = { addressFormat: { value: 'full', display: 'Full Address' } };
    this.formatOptions = [
      { value: 'full', display: 'Full Address' },
      { value: 'street', display: 'Street' },
    ];
  }

  componentDidMount = async () => {
    const selectedAnnots = this.props.annotManager.getSelectedAnnotations();

    const annots = _.filter(selectedAnnots, (a) => annotNameIncludes(a, 'Template'));

    if (annots) {
      const addressFormat = _.chain(annots)
        .head()
        .get('CustomData.flags.addressFormat')
        .value();

      await this.setState({ addressFormat });
    }
  }


  render() {
    const selectedAnnots = this.props.annotManager.getSelectedAnnotations();
    const annots = getTemplateAnnots(selectedAnnots);

    // TODO: set annot.Author and annot.CustomData.type
    if (annots.length === selectedAnnots.length) {
      return (
        <div style={{ paddingRight: 5 }}>
          <label htmlFor='signer'>Address Format: </label>
          <select
            value={this.state.addressFormat}
            onChange={(ev) => {
              _.map(annots, (a) => {
                if (_.isNil(a.setAddressFormat)) {
                  setAddressFormat(a, ev.target.value, _.find(this.props.signers, { id: a.CustomData.signerId }), this.props.instance);
                } else {
                  a.setAddressFormat(ev.target.value, _.find(this.props.signers, { id: a.CustomData.signerId }));
                }

                this.setState({ addressFormat: ev.target.value });
              });
            }}
          >
            {
              _.map(this.formatOptions, (format, index) => (
                <option
                  key={index}
                  value={format.value}
                >
                  {format.display}
                </option>
              ))
            }
          </select>
        </div>
      );
    }

    return null;
  }
}
